import { useState, useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import Grid from "@mui/material/Grid"
import Card from "@mui/material/Card"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import MDButton from "components/MDButton"
import DashboardLayout from "monitor/LayoutContainers/DashboardLayout"
import DashboardNavbar from "monitor/Navbars/DashboardNavbar"
import Footer from "monitor/Footer"
import MDInput from "components/MDInput"
import { Link } from "react-router-dom"
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
  Chip,
  Checkbox,
  FormControlLabel,
} from "@mui/material"
import { showToast } from "utils/swalToast"
import {
  fetchPost,
  fetchZonaById,
  updateZona,
  fetchSucursales,
  fetchEventos,
  fetchEmpresas,
} from "./service"
import ModalSelectorMultiple from "components/ModalSelectorMultiple"

function Add() {
  const mode = localStorage.getItem("checkboxState")
  const [zonaToEdit, setZonaToEdit] = useState(null)
  const navigate = useNavigate()
  const { id } = useParams()
  const [formData, setFormData] = useState({
    descripcion: "",
    option: [],
    optionEvento: [],
    codigoZona: "",
    activo: true,
  })
  const [option, setOption] = useState([])
  const [optionEventos, setOptionEventos] = useState([])
  const [sucursales, setSucursales] = useState([])
  const [eventos, setEventos] = useState([])
  const [optionEmpresa, setOptionEmpresa] = useState("")
  const [empresas, setEmpresas] = useState([])

  useEffect(() => {
    fetchEmpresas().then((data) => {
      setEmpresas(data)
    })
  }, [])

  useEffect(() => {
    if (id) {
      fetchZonaById(id).then((zo) => {
        setZonaToEdit(zo)
        setFormData({
          descripcion: zo.descripcion || "",
          option: zo.sucursales?.map((sucursal) => sucursal.idSucursal), // Store IDs
          activo: zo.activo,
          codigoZona: zo.codigoZona,
        })
        console.log(zo.empresa)
        setOptionEmpresa(zo.empresa.idEmpresa)
        if (zo.empresa.idEmpresa) {
          fetchSucursales(zo.empresa.idEmpresa)
            .then((data) => {
              setSucursales(data)
            })
            .catch((error) => {
              console.error("Error fetching sucursales:", error)
            })
        }
        setOption(zo.sucursales?.map((sucu) => sucu.idSucursal))
        if (zo.empresa.idEmpresa) {
          fetchEventos(zo.empresa.idEmpresa)
            .then((data) => {
              setEventos(data)
            })
            .catch((error) => {
              console.error("Error fetching eventos:", error)
            })
        }
        setOptionEventos(zo.eventos?.map((evento) => evento.idEvento))
      })
    }
  }, [id])

  const handleChange = (event) => {
    const { name, value } = event.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleEmpresaChange = (e) => {
    const selectedId = e.target.value // Get selected idSucursal
    setOption([])
    setOptionEventos([])
    setOptionEmpresa(selectedId) // Update the selected option
    fetchSucursales(selectedId)
      .then((data) => {
        setSucursales(data) // Update zonas state with fetched data
      })
      .catch((error) => {
        console.error("Error fetching zonas:", error)
      })
    fetchEventos(selectedId)
      .then((data) => {
        setEventos(data) // Update zonas state with fetched data
      })
      .catch((error) => {
        console.error("Error fetching zonas:", error)
      })
  }

  const handleChangeSelect = (event) => {
    const {
      target: { value },
    } = event
    setOption(typeof value === "string" ? value.split(",") : value)
  }

  const handleChangeSelectEventos = (event) => {
    const {
      target: { value },
    } = event
    setOptionEventos(typeof value === "string" ? value.split(",") : value)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    console.log(optionEventos)
    console.log(eventos)
    const data = {
      descripcion: e.target.descripcion.value,
      sucursales: sucursales.filter((sucur) => option.includes(sucur.idSucursal)),
      eventos: eventos.filter((eve) => optionEventos.includes(eve.idEvento)),
      activo: Boolean(formData.activo),
      codigoZona: formData.codigoZona,
      empresa: { idEmpresa: optionEmpresa },
    }

    try {
      if (zonaToEdit) {
        await updateZona(id, data)
        showToast({ title: "Zona actualizada exitosamente", icon: "success" })
      } else {
        await fetchPost(data)
        showToast({ title: "Zona agregada exitosamente", icon: "success" })
      }
      navigate("/zonas")
    } catch (error) {
      console.error("Error en la operación:", error)
    }
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={3} mb={3}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={8}>
            <Card>
              <MDBox p={2}>
                <MDTypography variant="h5">
                  {zonaToEdit ? "Editar zona" : "Agregar zona"}
                </MDTypography>
              </MDBox>
              <MDBox
                pt={2}
                px={2}
                id="formAddUs"
                onSubmit={handleSubmit}
                component="form"
                role="form"
              >
                <MDBox mb={2}>
                  <MDInput
                    type="text"
                    name="descripcion"
                    label="Nombre"
                    required
                    fullWidth
                    value={formData.descripcion}
                    onChange={handleChange}
                  />
                </MDBox>
                <MDBox mb={2}>
                  <FormControl fullWidth>
                    <InputLabel>Empresa</InputLabel>
                    <Select
                      type="text"
                      name="empresa"
                      value={optionEmpresa}
                      label="Empresa"
                      required
                      onChange={handleEmpresaChange}
                      fullWidth
                      sx={{ p: 1.5 }}
                    >
                      {empresas?.map((emp) => (
                        <MenuItem key={emp.idEmpresa} value={emp.idEmpresa}>
                          {emp.descripcion}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </MDBox>
                <MDBox mb={2}>
                  <ModalSelectorMultiple
                    value={option || []}
                    onChange={setOption}
                    items={sucursales}
                    itemValue="idSucursal"
                    itemLabel="descripcion"
                    renderChip={(sucur) => `${sucur.empresa?.descripcion} - ${sucur.descripcion}`}
                    label="Sucursales"
                    placeholder="Seleccione sucursales"
                    searchPlaceholder="Buscar sucursal..."
                    emptyText="No se encontraron sucursales"
                    fullWidth
                  />
                </MDBox>
                <MDBox mb={2}>
                  <ModalSelectorMultiple
                    value={optionEventos || []}
                    onChange={setOptionEventos}
                    items={eventos}
                    itemValue="idEvento"
                    itemLabel="descripcion"
                    renderChip={(eve) => `${eve.empresa?.descripcion} - ${eve.descripcion}`}
                    label="Eventos"
                    placeholder="Seleccione eventos"
                    searchPlaceholder="Buscar evento..."
                    emptyText="No se encontraron eventos"
                    fullWidth
                  />
                </MDBox>
                <MDBox mb={2}>
                  <MDInput
                    type="text"
                    name="codigoZona"
                    label="Código de Zona"
                    fullWidth
                    value={formData.codigoZona}
                    onChange={handleChange}
                  />
                </MDBox>
                <MDBox mb={2}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="activo"
                        checked={Boolean(formData.activo)}
                        onChange={(e) =>
                          handleChange({
                            target: { name: "activo", value: e.target.checked },
                          })
                        }
                      />
                    }
                    label="ACTIVO"
                  />
                </MDBox>
                <MDBox mb={2} sx={{ textAlign: "center" }}>
                  <MDButton type="submit" variant="gradient" color="info" sx={{ mr: 1, width: 90 }}>
                    {zonaToEdit ? "Actualizar" : "Agregar"}
                  </MDButton>
                  <Link to="/zonas">
                    <MDButton
                      type="button"
                      variant="outlined"
                      color="info"
                      sx={{ mr: 1, width: 90 }}
                    >
                      Cancelar
                    </MDButton>
                  </Link>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  )
}

export default Add
